import {
  slackPersonalService
} from "../services/api";
import type {
  SlackPersonalConversation
} from "../services/api";
import {
  PersonalReadAccessModal
} from "./PersonalReadAccessModal";
import type {
  PersonalReadAccessConfig
} from "./PersonalReadAccessModal";

interface SlackPersonalAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDisconnect: () => Promise<void>;
  /** Fired after the list is saved so the tile's detail can refresh. */
  onSaved: () => Promise<void>;
}

const SLACK_CONFIG: PersonalReadAccessConfig<SlackPersonalConversation> = {
  title: "Slack — what your assistant can read",
  intro:
    "Your assistant reads these through your own Slack account, read-only. It can never post, "
    + "react, or mark anything as read. Tick what it may read.",
  radioName: "slack-personal-mode",
  searchPlaceholder: "Find a channel or person",
  kindOrder: { channel: 0, private_channel: 1, dm: 2, group_dm: 3 },
  kindLabel: {
    channel: "Channel",
    private_channel: "Private channel",
    dm: "Direct message",
    group_dm: "Group message",
  },
  displayName: (c) => (c.kind === "dm" || c.kind === "group_dm" ? c.name : `#${c.name}`),
  incompleteNote:
    "You're in more conversations than we could list. Ones missing here can't be ticked yet; "
    + "leave a conversation in Slack you no longer need, or ask your assistant to request access "
    + "to it by name.",
  loadError: "Couldn't load your Slack conversations.",
  listConversations: () => slackPersonalService.listConversations(),
  saveAccess: (mode, ids) => slackPersonalService.updateAccess({ access_mode: mode, channel_ids: ids }),
};

/**
 * Which of the owner's Slack conversations the assistant may read through
 * their personal (read-only) connection — GET-14181.
 */
export function SlackPersonalAccessModal(props: SlackPersonalAccessModalProps) {
  return <PersonalReadAccessModal {...props} config={SLACK_CONFIG} />;
}
